export default __webpack_public_path__ + "static/TextEditing-2529ca84ae5a97dd9bd3da74d0b86e85.png";